export const CATEGORIES = [
  {
    id: 1,
    slug: 'after-effects-templates',
    name: 'After Effects Templates',
    category_type_id: 1,
  },
  {
    id: 2,
    slug: 'stock-video',
    name: 'Stock Video',
    category_type_id: 4,
  },
  {
    id: 3,
    slug: 'stock-motion-graphics',
    name: 'Stock Motion Graphics',
    category_type_id: 4,
  },
  {
    id: 4,
    slug: 'royalty-free-music',
    name: 'Royalty Free Music',
    category_type_id: 3,
  },
  {
    id: 5,
    slug: 'premiere-pro-templates',
    name: 'Premiere Pro Templates',
    category_type_id: 1,
  },
  {
    id: 6,
    slug: 'motion-graphics-templates',
    name: 'Motion Graphics Templates',
    category_type_id: 1,
  },
  {
    id: 7,
    slug: 'sound-effects',
    name: 'Sound Effects',
    category_type_id: 3,
  },
  {
    id: 8,
    slug: 'premiere-pro-presets',
    name: 'Premiere Pro Presets',
    category_type_id: 2,
  },
  {
    id: 9,
    slug: 'after-effects-presets',
    name: 'After Effects Presets',
    category_type_id: 2,
  },
  {
    id: 10,
    slug: 'davinci-resolve-templates',
    name: 'DaVinci Resolve Templates',
    category_type_id: 1,
  },
  {
    id: 11,
    slug: 'premiere-rush-templates',
    name: 'Premiere Rush Templates',
    category_type_id: 1,
  },
  {
    id: 12,
    slug: 'davinci-resolve-macros',
    name: 'DaVinci Resolve Macros',
    category_type_id: 1,
  },
  {
    id: 13,
    slug: 'final-cut-pro-templates',
    name: 'Final Cut Pro Templates',
    category_type_id: 1,
  },
  {
    id: 14,
    slug: 'stock-photos',
    name: 'Stock Photos',
    category_type_id: 5,
  },
  {
    id: 15,
    slug: 'graphics',
    name: 'Graphics',
    category_type_id: 5,
  },
];
